const sha256 = (plain: string): Promise<ArrayBuffer> => {
	// returns promise ArrayBuffer
	const encoder = new TextEncoder();
	const data = encoder.encode(plain);
	return window.crypto.subtle.digest('SHA-256', data);
};

const base64urlencode = (a: ArrayBuffer): string => {
	// Convert the ArrayBuffer to string using Uint8 array.
	// btoa takes chars from 0-255 and base64 encodes.
	// Then convert the base64 encoded to base64url encoded.
	// (replace + with -, replace / with _, trim trailing =)
	const base64Arr = new Uint8Array(a) as unknown as number[];

	return btoa(String.fromCharCode.apply(null, base64Arr))
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.replace(/=+$/, '');
};

const getRandomInt = (min: number, max: number): number => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const pkce_challenge_from_verifier = async (
	v: string
): Promise<string> => {
	const hashed = await sha256(v);
	const base64encoded = base64urlencode(hashed);
	return base64encoded;
};

export const create_pkce_verifier = (): string => {
	const mask =
		'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~';
	const length = getRandomInt(43, 128);

	let result = '';

	const randomIndices = new Int8Array(length);
	window.crypto.getRandomValues(randomIndices);

	const byteLength = 256;
	const maskLength = Math.min(mask.length, byteLength);
	const scalingFactor = byteLength / maskLength;

	for (let i = 0; i < length; i++) {
		result += mask[Math.floor(Math.abs(randomIndices[i]) / scalingFactor)];
	}

	return result;
};
